import React from 'react';

import { oxfordComma } from '../../lib/stringUtils';
import { cn } from '../../lib/utils';

// errorMessages should be an array of strings
const SettingsTextarea = ({ className = '', errorMessages, ...props }) => {
  const hasError = !!errorMessages;

  const messages = Array.isArray(errorMessages) ? errorMessages : [errorMessages];
  const errorText = messages
    .map((message, index) => {
      const separator = oxfordComma(index, messages.length);
      return message + separator;
    })
    .join('');

  return (
    <div className="w-full">
      <textarea
        {...props}
        className={cn(
          'block h-64 w-full resize-none rounded-xl border p-4 text-cursed/5 text-black placeholder:text-gray-500 focus:outline-none dark:bg-neutral-900 dark:text-neutral-200',
          hasError
            ? 'border-red-400 focus:border-red-400'
            : 'border-gray-200 bg-gray-200/40 focus:border-gray-400 dark:border-neutral-800 dark:focus:border-neutral-700',
          className,
        )}
      />
      {hasError && <span className="mt-1 block text-xs text-red-400">{errorText}</span>}
    </div>
  );
};

export default SettingsTextarea;
